import { Action } from '@ngrx/store';

export const CREATE_FORM = "Create final form"
export const UPDATE_FORM = "Update final form"

export class FinalFormCreate implements Action {
    readonly type = CREATE_FORM;
    constructor(
        public formulario  ?,
        public tipo_solicitud ?,
        public tipo_recepcion ?,
        public propiedad  ?,
        public propietarios ?,
        public representantes ?,
        public arquitectos ?,
        public empresas ?,
        public constructores ?,
        public constructora ?,
        public independiente ?,
        public informe ?,
        public declaracion ?,
        public permiso_notariado ?,
        public cip ?,
        public proyecto ?,
        public plazo ?,
        public antecedentes ?,
        public caracteristica_proyecto ?,
        public datos_proyecto ?,
        public antecedentes_edif ?,
        public anteproy_condominio ?,
        public autorizaciones ?,
        public clasificacion ?,
        public condiciones ?,
        public disposicion ?,
        public disposiciones_esp ?,
        public normas_urbanisticas ?,
        public recepcion ?,
        public recepcion_parcial ?,
        public registro_bienes ?,
        public superficie ?,
        public superficie_anteproyecto ?,
        public unidades ? ,
        public uso_publico ?,
        public ampliacion ?,
        public archivos ? ,
        public Permisos ? ,
        public permisos_recep ?,
        public permisos_recepciones ?,
        public idusuario_mongo ?
    
    ){}
}

export type All = FinalFormCreate;